module.exports = __webpack_public_path__ + "img/smoke.e7abd077.png";